import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import Lity from "lity"
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

import "blocks/SITE/SITEQuoteForm";

jQuery(function ($) {
    Components.init();
    Plugins.init();

    if ($('.single-project .wp-block-gallery').length) {
        $(document).on('click', '.single-project .wp-block-gallery .wp-block-image img', Lity);
    }

    if ($('#hero-slider').length) {
        $('#hero-slider').slick({
            arrows: true,
            appendArrows: '.hero-arrows',
            adaptiveHeight: false,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            appendDots: '.hero-dots',
            autoplay: true,
            autoplaySpeed: 8000,
            pauseOnHover: false,
            fade: true,
            customPaging: function (slider, i) {
                return '<button><span><span></span></span></button>';
            },
        })
    }

    Fancybox.bind("[data-fancybox]", {
        // Your custom options
      });
      
    // Handle location page maps

    var icon = L.icon({
        iconUrl: '/wp-content/themes/nulofts/assets/img/location-b.png',
        iconSize: [45, 45],
        iconAnchor: [22.5, 45]
    });

    var activeIcon = L.icon({
        iconUrl: '/wp-content/themes/nulofts/assets/img/location-b.png',
        iconSize: [63, 63],
        iconAnchor: [31.5, 63]
    });

    $('.location').each(function () {

        var $container = $(this);
        var $map = $container.find('.location-map');

        var locationCoordinates = $map.data('location-coordinates');

        var coordinates = [];
        Object.keys(locationCoordinates).forEach(function (id) {
            coordinates.push([locationCoordinates[id]['lat'], locationCoordinates[id]['long']]);
        });

        // initialise map
        var map = L.map($map[0], {
            zoom: 2,
            zoomControl: false,
            scrollWheelZoom: false,
            maxBounds: [[-90, -180], [90, 180]] // limit to whole world
        });

        // pan to fit markers
        if (coordinates.length > 1) {
            map.fitBounds(coordinates, {
                padding: [50, 50]
            });
        } else {
            map.setView(coordinates[0], 12);
        }

        // add tiles to map
        L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap Contributors. Tiles courtesy of Humanitarian OpenStreetMap Team',
            minZoom: 2,
            maxZoom: 20,
            ext: 'png',
            noWrap: true
        }).addTo(map);

        Object.keys(locationCoordinates).forEach(function (id) {

            // add marker to map
            var marker = L.marker([locationCoordinates[id]['lat'], locationCoordinates[id]['long']], {
                icon: icon
            }).addTo(map);

            L.circle([locationCoordinates[id]['lat'], locationCoordinates[id]['long']], {
                radius: 2500,
                color: '#304b57',
                fillOpacity: 0.25,
                stroke: false
            }).addTo(map);

            locationCoordinates[id].marker = marker;

            if (locationCoordinates[id]['url'] !== undefined) {
                marker.on('click', function () {
                    window.location = locationCoordinates[id]['url'];
                });
            }
        });

        var locationCards = $container.find('.location-panel-location a[data-location-id]');

        locationCards.on('mouseenter', function () {

            var locationCard = $(this);
            var locationId = locationCard.data('location-id');

            locationCoordinates[locationId].marker.setIcon(activeIcon);
        });

        locationCards.on('mouseleave', function () {

            var locationCard = $(this);
            var locationId = locationCard.data('location-id');

            locationCoordinates[locationId].marker.setIcon(icon);
        });
    });

});

document.addEventListener("DOMContentLoaded", () => {
    const slickBtnsContainer = document.querySelector('.hero-arrows');
    const arrowSvgContent = document.querySelector('#arrow-svg').innerHTML;

    const observer = new MutationObserver(() => {
        const slickPrev = slickBtnsContainer.querySelector('.slick-prev');
        const slickNext = slickBtnsContainer.querySelector('.slick-next');

        if (slickPrev && slickNext) {
            slickPrev.innerHTML = arrowSvgContent;
            slickNext.innerHTML = arrowSvgContent;
            observer.disconnect();
        }
    });

    observer.observe(slickBtnsContainer, { childList: true });
});